// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31w0l","title":"Info_title__1CwyB","selects":"Info_selects__mIfKC","requiredAsterisk":"Info_requiredAsterisk__3UBKC"};